import React from 'react';

const getButtonClasses = (id, isActive) => {
  const baseClasses = `
    flex items-center justify-between gap-2.5 sm:gap-3 p-3 sm:px-3.5 sm:py-3
    text-white rounded-xl shadow-sm transition-all duration-300
    hover:shadow-md hover:-translate-y-0.5
    cursor-pointer w-full h-full text-left group
  `;
  
  const gradientMap = {
    "Print Design": "bg-gradient-to-r from-green-500 to-green-400",
    "Packaging Design": "bg-gradient-to-r from-orange-500 to-orange-400",
    "Digital Graphics": "bg-gradient-to-r from-blue-500 to-blue-400",
    "Branding Design": "bg-gradient-to-r from-purple-500 to-purple-400",
    "Branding": "bg-gradient-to-r from-purple-500 to-purple-400"
  };
  
  const activeRingMap = {
    "Print Design": "ring-4 ring-green-300 ring-opacity-50",
    "Packaging Design": "ring-4 ring-orange-300 ring-opacity-50",
    "Digital Graphics": "ring-4 ring-blue-300 ring-opacity-50",
    "Branding Design": "ring-4 ring-purple-300 ring-opacity-50",
    "Branding": "ring-4 ring-purple-300 ring-opacity-50"
  };
  
  const gradient = gradientMap[id] || "bg-gradient-to-r from-gray-500 to-gray-400";
  const activeRing = isActive ? (activeRingMap[id] || "ring-4 ring-gray-300 ring-opacity-50") : "";
  
  return `${baseClasses} ${gradient} ${activeRing}`;
};

export const DesigningCategoryButtons = ({ selectedType, onFilterChange }) => {
  const typeMapping = {
    "Print Design": "print",
    "Packaging Design": "packing",
    "Digital Graphics": "digital",
    "Branding Design": "branding",
    "Branding": "branding"
  };
  
  const categories = [
    { id: "Print Design", label: "Print Design", description: "Brochures, Flyers, Posters & more", className: "icon-1" },
    { id: "Packaging Design", label: "Packaging Design", description: "Labels, Boxes, Pouches & more", className: "icon-2" },
    { id: "Digital Graphics", label: "Digital Graphics", description: "Banners, Creatives & more", className: "icon-3" },
    { id: "Branding Design", label: "Branding Design", description: "Logo, Identity, Brand Kit & more", className: "icon-4" }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-6 bg-white rounded-2xl p-2 sm:p-2.5 w-full shadow-sm">
      {categories.map((cat) => {
        const typeValue = typeMapping[cat.id];
        const isActive = selectedType === typeValue;
        return (
          <button
            key={cat.id}
            onClick={() => onFilterChange("type", isActive ? "All" : typeValue)}
            className={getButtonClasses(cat.id, isActive)}
          >
            <div className="flex items-center gap-2.5 sm:gap-3 w-full h-full min-w-0">
              <div className="flex-shrink-0 flex items-center justify-center w-11 h-11 sm:w-12 sm:h-12 rounded-xl bg-white/15 backdrop-blur-sm p-1.5 shadow-inner transition-transform duration-300 group-hover:scale-105 overflow-hidden">
                <div className="flex items-center justify-center transform scale-[0.68] sm:scale-[0.75]">
                  <span className={`custom-icon ` + cat.className} />
                </div>
              </div>
              <div className="flex flex-col flex-1 justify-center min-w-0 my-auto text-left">
                <span className="notosans-semibold text-xs sm:text-[13px] xl:text-[14px] font-bold text-white leading-tight tracking-wide line-clamp-2">
                  {cat.label}
                </span>
                <span className="text-[11px] sm:text-xs font-normal text-white/95 leading-snug mt-0.5 line-clamp-2">
                  {cat.description}
                </span>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
};
